import {
  ShoppingBag,
  Truck,
  Scissors,
  BadgeCheck,
  Users,
  MapPin,
} from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const CARDS = [
  {
    icon: ShoppingBag,
    title: "Everything in One Place",
    text: "Clothing, footwear, accessories, innerwear and home essentials — a complete family store.",
  },
  {
    icon: Users,
    title: "For Men & Women",
    text: "A wide range of garments and services for every member of the family.",
  },
  {
    icon: Scissors,
    title: "Professional Alterations",
    text: "In-house boutique and alteration services for both men and women.",
  },
  {
    icon: BadgeCheck,
    title: "Trusted Brands",
    text: "Footwear and innerwear from recognised, well-loved brands.",
  },
  {
    icon: Truck,
    title: "Free Local Delivery",
    text: "Free home delivery within 5 km on orders above ₹1,500.",
  },
  {
    icon: MapPin,
    title: "Easy to Reach",
    text: "On Kanakapura Main Road at Udayapura — open daily 8 AM to 10 PM, with easy local connectivity.",
  },
];

export const WhyChoose = () => (
  <section className="bg-cream text-charcoal py-16 sm:py-24 lg:py-28">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal className="max-w-2xl">
        <Eyebrow light>Why Om Sri Sri Collection</Eyebrow>
        <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-balance">
          One store for the whole family's everyday needs.
        </h2>
      </Reveal>
      <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6">
        {CARDS.map(({ icon: Icon, title, text }, i) => (
          <Reveal key={title} delay={i * 0.07}>
            <div
              data-testid={`why-card-${i + 1}`}
              className="group h-full bg-white border border-cream-line rounded-3xl p-7 transition-all duration-300 hover:-translate-y-1.5 hover:shadow-[0_24px_50px_-20px_rgba(18,18,18,0.18)] hover:border-gold/50"
            >
              <div className="w-12 h-12 rounded-2xl bg-gold/15 flex items-center justify-center text-gold-deep group-hover:bg-gold group-hover:text-charcoal transition-colors duration-300">
                <Icon size={22} strokeWidth={2} />
              </div>
              <h3 className="mt-5 font-display text-xl font-semibold">{title}</h3>
              <p className="mt-2.5 text-sm sm:text-base text-charcoal/60 leading-relaxed">
                {text}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
